import React, { Fragment, useState, useEffect } from "react";
import FcardContact from "../../components/FcardContact/FcardContact";
import FcardGroup from "../../components/FcardGroup/FcardGroup";
import FcardPageTitle from "../../components/FcardPageTitle/FcardPageTitle";
import { useNavigate } from "react-router";
import FAddressCard from "../../components/FAddressCard/FAddressCard";
import { getAddress, deleteAddressById } from "../../api/address";
import Floading from "../../components/Floading/Floading";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import FInputt from "../../components/FInputt/FInputt";
import { useConfig } from "../../hooks/useConfig";
import { useFormik } from "formik";
import { useFormat } from "../../hooks/useFormat";
import FInputText from "../../components/Finputs/FInputText/FInputText";
import FContainer from "../../components/FContainer/FContainer";
import Fbutton from "../../components/Finputs/FButton/Fbutton";

const ChangePasswordScreen = ({ param }) => {
  const { updatePassword } = useConfig();
  const route = useNavigate();
  const { checkPassword } = useFormat();

  const nextScreen = async (data) => {
    const response = await updatePassword(data);
    if (response[0]) {
      Swal.fire({
        showCloseButton: true,
        title: "Éxito",
        text: "Contraseña cambiada satisfactoriamente",
        imageUrl: require("../../components/assets/images/comprobado.png"),
        imageWidth: 150,
        imageHeight: 150,
        imageAlt: "Custom image",
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#dc3545",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          route("/ConfigScreen");
        }
      });
    } else {
      if (response[1] == "INVALID_CURRENT_PASSWORD") {
        Swal.fire({
          showCloseButton: true,
          title: "Error",
          text: "Contraseña actual invalida",
          imageUrl: require("../../components/assets/images/boton-x.png"),
          imageWidth: 150,
          imageHeight: 150,
          imageAlt: "Custom image",
          confirmButtonColor: "#28a745",
          cancelButtonColor: "#dc3545",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          reverseButtons: true,
        });
      } else {
        Swal.fire({
          showCloseButton: true,
          title: "Error",
          text: "No se pudo cambiar la contraseña",
          imageUrl: require("../../components/assets/images/boton-x.png"),
          imageWidth: 150,
          imageHeight: 150,
          imageAlt: "Custom image",
          confirmButtonColor: "#28a745",
          cancelButtonColor: "#dc3545",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          reverseButtons: true,
        });
      }
    }
  };

  const formik = useFormik({
    initialValues: {
      newPassword: "",
      currentPassword: "",
    },
    onSubmit: async (values) => {
      const { currentPassword, newPassword } = values;
      nextScreen({ currentPassword, newPassword });
    },
    validate: (values) => {
      const errors = {};
      if (!values.newPassword) {
        errors.newPassword = "Ingresa tu nueva contraseña.";
      } else {
        if (values.newPassword.length < 6) {
          errors.newPassword =
            "Tu contraseña debe tener al menos 6 caracteres.";
        } else {
          if (!checkPassword(values.newPassword)) {
            errors.newPassword =
              "Escribe una contraseña valida. (Usa letras, numeros y signos)";
          }
        }
      }

      if (!values.currentPassword) {
        errors.currentPassword = "Tienes que ingresar tu contraseña actual";
      } else {
        if (values.currentPassword.length < 6) {
          errors.currentPassword =
            "Tu contraseña debe tener al menos 6 caracteres.";
        } else {
          if (!checkPassword(values.currentPassword)) {
            errors.currentPassword =
              "Escribe una contraseña valida. (Usa letras, numeros y signos)";
          }
        }
      }
      return errors;
    },
  });

  useEffect(() => {
    formik.setFieldValue("currentPassword", "");
  }, []);
  return (
    <>
      <FContainer>
        <FInputText
          title="Ingresa tu contraseña actual"
          placeholder="Ingresa tu contraseña actual"
          type="PasswordInput"
          onChange={(value) => {
            formik.setFieldValue("currentPassword", value);
          }}
          errorMessage={formik.values.currentPassword == "" ? "" : formik.errors.currentPassword}
        />
        <FInputText
          title="Ingresa tu nueva contraseña"
          placeholder="Ingresa tu nueva contraseña"
          type="PasswordInput"
          onChange={(value) => {
            formik.setFieldValue("newPassword", value);
          }}
          errorMessage={formik.values.newPassword == "" ? "" : formik.errors.newPassword}
        />
        <Fbutton
          value="Cambiar contraseña"
          disabled={!formik.isValid}
          onClick={formik.handleSubmit}
        />
      </FContainer>
    </>
  );
};

export default ChangePasswordScreen;
